import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortModule, MatSortHeader } from '@angular/material/sort';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class MaterialsComponent implements OnInit {
  hasApiError = false;
  apiError: string;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [
    'id',
    'name',
    'key_words',
    'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig

  ) { }

  ngOnInit(): void {
    this.getMaterials()
  }

  getMaterials() {
    this.api.getMaterials$().subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.dataSource = new MatTableDataSource<any>(res);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }

  deleteMaterial(id: string) {
    this.api.deleteMaterialsId$(id).subscribe({
      next: () => {
        this.hasApiError = false;
        this.getMaterials()
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }
}
